import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { EmptyState } from "@/components/common/EmptyState";
import { SurfaceCard } from "@/components/common/Cards";
import { StatusBadge } from "@/components/common/StatusBadge";
import { relativeDay } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogTrigger } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { ListTodo, Plus } from "lucide-react";
import { toast } from "sonner";

export default function Tasks() {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const load = () => api.get("/tasks").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const create = async () => { if (!title.trim()) return; await api.post("/tasks", { title }); setTitle(""); setOpen(false); toast.success("Task added"); load(); };
  const toggle = async (t) => { await api.put(`/tasks/${t.id}`, { status: t.status === "done" ? "todo" : "done" }); load(); };

  return (
    <div>
      <PageHeader title="Tasks" subtitle="Team to-dos and clinical action items" breadcrumb={["Practice", "Tasks"]}
        actions={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild><Button data-testid="add-task-btn" className="bg-[#00A85A] hover:bg-[#008F4D] text-white rounded-lg"><Plus className="h-4 w-4 mr-1.5" />Add Task</Button></DialogTrigger>
            <DialogContent className="sm:max-w-md"><DialogHeader><DialogTitle>New Task</DialogTitle></DialogHeader>
              <div className="py-2"><Label className="text-xs font-semibold">Task</Label><Input value={title} onChange={(e) => setTitle(e.target.value)} className="mt-1" data-testid="task-title-input" /></div>
              <DialogFooter><Button onClick={create} data-testid="save-task-btn" className="w-full bg-[#00A85A] hover:bg-[#008F4D] text-white rounded-lg">Add</Button></DialogFooter>
            </DialogContent>
          </Dialog>
        } />
      {items && items.length === 0 ? (
        <EmptyState icon={ListTodo} title="No tasks" description="Create a task to keep your team aligned." actionLabel="Add Task" onAction={() => setOpen(true)} testId="tasks-empty" />
      ) : (
        <div className="space-y-2.5">
          {(items || []).map((t) => (
            <SurfaceCard key={t.id} className="p-4">
              <div className="flex items-center gap-3">
                <Checkbox checked={t.status === "done"} onCheckedChange={() => toggle(t)} data-testid={`task-check-${t.id}`} />
                <div className="flex-1 min-w-0"><div className={`text-sm font-semibold ${t.status === "done" ? "line-through text-[#8B9698]" : "text-[#101516] dark:text-white"}`}>{t.title}</div><div className="text-xs text-[#8B9698]">{t.assignee} · Due {relativeDay(t.due_date)}</div></div>
                {t.priority === "high" && <StatusBadge status="error" label="High" />}
                <StatusBadge status={t.status} />
              </div>
            </SurfaceCard>
          ))}
        </div>
      )}
    </div>
  );
}
